import { mentionVariantForKind } from '#pplx/frontend/composer-sdk/internal/mention/mentionVariant.js';
import { $isMentionNode } from '#pplx/frontend/composer-sdk/lexical/nodes/MentionNodeSupport.js';
import { $getRoot, $isElementNode, $isTextNode, SKIP_DOM_SELECTION_TAG } from 'lexical';
export function removeMention(editor, identity) {
    let result = 'not-found';
    editor.update(() => {
        const variant = mentionVariantForKind(identity.kind);
        if (removeMentionFromTree($getRoot(), identity.id, variant)) {
            result = 'removed';
        }
    }, {
        // Semantic mutation may update Lexical's selection but must not move DOM focus away from
        // the host action. The surface chooses whether to focus Composer after the mutation.
        discrete: true,
        tag: SKIP_DOM_SELECTION_TAG,
    });
    return result;
}
function removeMentionFromTree(node, id, variant) {
    if ($isMentionNode(node)) {
        if (node.__props.uuid !== id || node.__props.variant !== variant) {
            return false;
        }
        removeFollowingInsertedSpace(node);
        node.remove();
        return true;
    }
    if (!$isElementNode(node)) {
        return false;
    }
    return node
        .getChildren()
        .reduce((removed, child) => removeMentionFromTree(child, id, variant) || removed, false);
}
function removeFollowingInsertedSpace(node) {
    const nextSibling = node.getNextSibling();
    if (!$isTextNode(nextSibling)) {
        return;
    }
    const text = nextSibling.getTextContent();
    if (text === ' ') {
        nextSibling.remove();
        return;
    }
    // A leading mention owns the first space in its following text. When non-whitespace text
    // precedes the mention, that space separates the surrounding text and must stay.
    if (text.startsWith(' ') && !hasPreviousTextSibling(node)) {
        nextSibling.setTextContent(text.slice(1));
    }
}
function hasPreviousTextSibling(node) {
    const previousSibling = node.getPreviousSibling();
    return $isTextNode(previousSibling) && previousSibling.getTextContent().trim() !== '';
}
//# sourceMappingURL=removeMention.js.map